import { MessageBus, type Event as MessageBusEvent } from '@podium/browser';
import React from 'react';

const MESSAGE_BUS_CHANNEL = 'search';
const MESSAGE_BUS_TOPIC = 'layout';

type SearchLayoutPayload = {
    layout: Layout;
};

export type Layout = 'grid' | 'list';

export function useSearchLayout(initialLayout: Layout) {
    const [layout, setLayout] = React.useState(initialLayout);

    React.useEffect(() => {
        function handleUpdatedLayout(ev: MessageBusEvent) {
            const payload = ev.payload as SearchLayoutPayload;
            setLayout(payload.layout);
        }

        const messageBus = new MessageBus();
        messageBus.subscribe(
            MESSAGE_BUS_CHANNEL,
            MESSAGE_BUS_TOPIC,
            handleUpdatedLayout,
        );

        return () =>
            messageBus.unsubscribe(
                MESSAGE_BUS_CHANNEL,
                MESSAGE_BUS_TOPIC,
                handleUpdatedLayout,
            );
    }, [setLayout]);

    return {
        layout,
    };
}
